// ============================================================
// 主催者登録フロー（F-19）
// 確認モーダル → POST /api/auth/me/organizer-registration →
// isOrganizer キャッシュ更新 → 主催者画面へ遷移。
// LandingPage の「イベントを開催する」とアバターメニューの
// 「主催者登録する」から共用する。
// ============================================================

import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { authApi, ApiError } from '@/services/api'
import { clearIsOrganizerCache } from '@/hooks/useIsOrganizer'
import { useConfirm, useAlert } from '@/components/ConfirmDialog'

export function useOrganizerRegistration() {
  const navigate = useNavigate()
  const confirm  = useConfirm()
  const alert    = useAlert()
  const [registering, setRegistering] = useState(false)

  const startRegistration = useCallback(async () => {
    const ok = await confirm({
      title:        '主催者登録しますか？',
      message:      'このアカウントで主催者用の団体が作成され、イベントの作成・運営ができるようになります。プレイヤーとしての情報はそのまま利用できます。',
      confirmLabel: '主催者登録する',
    })
    if (!ok) return
    setRegistering(true)
    try {
      await authApi.registerAsOrganizer()
      clearIsOrganizerCache()
      navigate('/events')
    } catch (e) {
      await alert({
        title:   'エラー',
        message: e instanceof ApiError ? e.message : '主催者登録に失敗しました',
      })
    } finally {
      setRegistering(false)
    }
  }, [alert, confirm, navigate])

  return { startRegistration, registering }
}
